module.exports = __webpack_public_path__ + "img/15-1.b66c4769.png";